function ConversionIcon(props) {
  return (
    <svg width={60} height={60} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="#fff" d="M0 0h60v60H0z" />
      <path
        d="M41.118 40.656H52.61c0-5.548-4.288-10.595-9.621-10.595-2.255 0-4.344.832-5.993 2.274 2.199 2.108 3.683 4.992 4.123 8.32zM42.982 29.552c2.824 0 5.113-2.31 5.113-5.159 0-2.849-2.289-5.159-5.113-5.159-2.824 0-5.113 2.31-5.113 5.16 0 2.848 2.289 5.158 5.113 5.158zM22.94 32.847c-1.65-1.498-3.74-2.44-6.048-2.44-5.279 0-9.622 5.103-9.622 10.65H18.76a13.882 13.882 0 014.179-8.21zM16.892 30.02c2.824 0 5.114-2.309 5.114-5.158 0-2.85-2.29-5.159-5.114-5.159s-5.113 2.31-5.113 5.159c0 2.85 2.29 5.159 5.113 5.159z"
        fill="#A8ADB2"
      />
      <path
        d="M16.864 44v.575h25.341v-.574c0-7.69-5.644-14.054-12.67-14.054-7.027 0-12.671 6.363-12.671 14.054z"
        fill="#A8ADB2"
        stroke="#fff"
        strokeWidth={1.149}
      />
      <path
        d="M29.591 29.744c3.553 0 6.433-2.906 6.433-6.49 0-3.585-2.88-6.49-6.433-6.49-3.552 0-6.433 2.905-6.433 6.49 0 3.584 2.88 6.49 6.433 6.49z"
        fill="#A8ADB2"
      />
    </svg>
  )
}

export default ConversionIcon
